/**
 * @param {import("@mui/material/styles").Theme} theme - The MUI theme object.
 * @returns {import("@stripe/stripe-js").Appearance} - Stripe Elements appearance object
 */
export const stripeElementsAppearance = (theme) => ({
  variables: {
    // General font styles
    fontFamily: theme.typography.fontFamily,
    fontLineHeight: theme.typography.lineHeight,
    // Font sizes
    fontSizeBase: theme.typography.fontSize,
    // Colors
    colorPrimary: theme.palette.primary.main,
    colorPrimaryText: theme.palette.primary.main,
    colorText: theme.palette.text.primary,
    colorSuccess: theme.palette.success.main,
    colorSuccessText: theme.palette.success.main,
    colorDanger: theme.palette.error.main,
    colorDangerText: theme.palette.error.main,
    colorWarning: theme.palette.warning.main,
    colorWarningText: theme.palette.warning.main,
    // Radius
    borderRadius: theme.shape.borderRadius + 'px',
  },
  rules: {
    '.Input--empty': {
      border: `1px solid ${theme.palette.warning.main}`,
    },
    '.Input:hover': {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
    '.Input:focus': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: 'none',
      outline: 'none',
    },
    '.Input:focus:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      boxShadow: 'none',
      outline: 'none',
    },
  },
});
